import styled from "styled-components";
import { useState, useEffect } from "react";
import IosSpinner from "../assets/gif/Spinner-1s-200px.gif";
import AosSpinner from "../assets/gif/Rolling-1s-200px.gif";

const StyledLoadingBackground = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  z-index: 20;
`;
const StyledLoadingGif = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width : 100%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
  z-index: 30;
  > img {
    position : absolute;
    top: 50%;
    left : 50%;
    transform: translate(-50%, -50%);
  }
`;

function Loading() {

  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  const [phoneType, setPhoneType] = useState();
  function checkMobile() {

    if (varUA.indexOf("android") > -1) {
      //안드로이드
      setPhoneType("android");
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setPhoneType("ios");
      return "ios";
    } else {
      //아이폰, 안드로이드 외
      setPhoneType("other");
      return "other";
    }
  }
  useEffect(() => {
    checkMobile();
  }, []);

  return (
    <>
      <StyledLoadingBackground />
      <StyledLoadingGif>
      {phoneType === "ios" ? (
        <img src={IosSpinner} className="loading" alt="로딩중" width="12%" />
      ) : (
        <img src={AosSpinner} className="loading" alt="로딩중" width="12%" />
      )}
      </StyledLoadingGif>
    </>
  );
}

export default Loading;
